import styles from '../styles/imgCard.module.css'
import logo from '../images/better.png'
export const ImageCard = () => {
    return(
    <div className={styles.card}>
        <img className={styles.image} src={logo} alt='bnb' />
    </div>
    );
}